import React from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import NewBusinessPartnerPage from 'pages/SuperAdminModule/BusinessPartnersManagement/NewBusinessPartnerPage';
import BusinessPartnersListPage from 'pages/SuperAdminModule/BusinessPartnersManagement/BusinessPartnersListPage';
import { BusinessPartnerManagementPage } from 'pages/SuperAdminModule/BusinessPartnersManagement/BusinessPartnerManagementPage';
import { businessPartnerManagementRoutes } from 'pages/SuperAdminModule/BusinessPartnersManagement/businessPartnerManagementRoutes';

export const BusinessPartnersManagementPage = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <PrivateRoute
        path={`${path}/${businessPartnerManagementRoutes.New}`}
        component={NewBusinessPartnerPage}
      />
      <PrivateRoute
        path={`${path}/${businessPartnerManagementRoutes.List}`}
        component={BusinessPartnersListPage}
      />
      <PrivateRoute
        path={`${path}/${businessPartnerManagementRoutes.Edit}`}
        component={BusinessPartnerManagementPage}
      />
      <Redirect to={`${path}/${businessPartnerManagementRoutes.List}`} />
    </Switch>
  );
};
